export default __webpack_public_path__ + "static/media/video-logo.a1926f4d.jpg";